module.exports = ".search-container button.go-back {\n  color: #26c6da;\n  border-radius: 20px;\n  border: 1px solid #26c6da;\n  padding: 0 16px;\n  margin-right: 20px; }\n  .search-container button.go-back span {\n    color: #26c6da !important; }\n  .capitalize {\n  text-transform: capitalize; }\n  :host ::ng-deep .shipment-container {\n  margin: 30px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shipments/components/shipment-info/shipment-info.component.scss
// module id = ./src/app/modules/shipments/components/shipment-info/shipment-info.component.scss
// module chunks = main